export default __webpack_public_path__ + "static/media/No4Open.7ab1a584.jpg";